/**
 * Finds a UK postcode in free text, e.g. "BS1 1AA" or "s102bt". Used as a check alongside AI:
 * if a buyer's address-change message contains a postcode, they've given an address, so we
 * never ask them for one. Number plates don't match (their second half has no digit).
 */
const POSTCODE = /\b([A-Z]{1,2}\d[A-Z\d]?)\s*(\d[A-Z]{2})\b/i;

export function findUkPostcode(text: string) {
  const match = POSTCODE.exec(text);
  return match ? `${match[1]} ${match[2]}`.toUpperCase() : undefined;
}
